export class FreezeTable{
    isThirdColum: boolean;
    className: string;
}